import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { 
    BrandRegistrationDataForm, 
    BrandRegistrationFilters, 
    BrandRegistrationStatusUpdate
} from '../../models/BrandRegistration';
import { ServiceEvents } from '../shared/interfaces';
import { buildEndpoint } from '../EndPoints';

const useBrandRegistrationService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    // Estados de carga
    const [fetchingGetBrandRegistrations, setFetchingGetBrandRegistrations] = useState(false);
    const [fetchingShowBrandRegistration, setFetchingShowBrandRegistration] = useState(false);
    const [fetchingStoreBrandRegistration, setFetchingStoreBrandRegistration] = useState(false);
    const [fetchingEditBrandRegistration, setFetchingEditBrandRegistration] = useState(false);
    const [fetchingCreateBrandRegistration, setFetchingCreateBrandRegistration] = useState(false);
    const [fetchingUpdateBrandRegistration, setFetchingUpdateBrandRegistration] = useState(false);
    const [fetchingDeleteBrandRegistration, setFetchingDeleteBrandRegistration] = useState(false);
    const [fetchingChangeStatusBrandRegistration, setFetchingChangeStatusBrandRegistration] = useState(false);

    // Base path para todos los endpoints
    const BASE_PATH = 'brand-registrations/brand-registrations';

    const getBrandRegistrations = (filters: BrandRegistrationFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filters)
            .filter(([_, value]) => value !== undefined && value !== '')
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        doGet({
            ...events,
            url: `${buildEndpoint(BASE_PATH)}?${queryString}`,
            setFetching: setFetchingGetBrandRegistrations
        });
    };

    const showBrandRegistration = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${id}/show`),
            setFetching: setFetchingShowBrandRegistration
        });
    };

    const storeBrandRegistration = (data: BrandRegistrationDataForm, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/store`),
            body: data,
            setFetching: setFetchingStoreBrandRegistration
        });
    };

    const createBrandRegistration = (events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/create`),
            setFetching: setFetchingCreateBrandRegistration
        });
    };

    const editBrandRegistration = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${id}/edit`),
            setFetching: setFetchingEditBrandRegistration
        });
    };

    const updateBrandRegistration = (id: number, data: BrandRegistrationDataForm, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${id}/update`),
            body: data,
            setFetching: setFetchingUpdateBrandRegistration
        });
    };

    const deleteBrandRegistration = (id: number, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${id}/delete`),
            body: {},
            setFetching: setFetchingDeleteBrandRegistration
        });
    };

    const changeStatusBrandRegistration = (id: number, statusData: BrandRegistrationStatusUpdate, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${id}/change-status`),
            body: statusData,
            setFetching: setFetchingChangeStatusBrandRegistration
        });
    };

    /** Sin lawyerId se asigna quien llama; con lawyerId, el admin del estudio asigna a uno de sus abogados. */
    const assignLawyer = (brandRegistrationId: number, events: ServiceEvents = {}, lawyerId?: number) => {
        doPost({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/assign-lawyer`),
            body: lawyerId
                ? { brand_registration_id: brandRegistrationId, lawyer_id: lawyerId }
                : { brand_registration_id: brandRegistrationId },
            setFetching: setFetchingChangeStatusBrandRegistration
        });
    };

    const [fetchingInapiBrandDetail, setFetchingInapiBrandDetail] = useState(false);

    const getInapiBrandDetail = (solicitud: string, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`brand-registrations/inapi/brand-detail/${solicitud}`),
            setFetching: setFetchingInapiBrandDetail
        });
    };

    return {
        fetchingGetBrandRegistrations,
        fetchingShowBrandRegistration,
        fetchingStoreBrandRegistration,
        fetchingEditBrandRegistration,
        fetchingCreateBrandRegistration,
        fetchingUpdateBrandRegistration,
        fetchingDeleteBrandRegistration,
        fetchingChangeStatusBrandRegistration,
        getBrandRegistrations,
        showBrandRegistration,
        storeBrandRegistration,
        createBrandRegistration,
        editBrandRegistration,
        updateBrandRegistration,
        deleteBrandRegistration,
        changeStatusBrandRegistration,
        assignLawyer,
        fetchingInapiBrandDetail,
        getInapiBrandDetail
    };
};

export default useBrandRegistrationService;
